"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _NavItem = _interopRequireDefault(require("./NavItem"));

var _menu = require("../constants/menu");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__nav-index__root",
  "expand": "meepshop-meep-ui__nav-index__expand",
  "wrapper": "meepshop-meep-ui__nav-index__wrapper"
};
var searchBarItem = [{
  id: (0, _v["default"])(),
  action: _menu.MENU_ACTION_TYPES.SEARCH_BAR,
  pages: [],
  newWindow: false,
  title: {
    zh_TW: '搜尋'
  }
}];

var Nav = function Nav(_ref) {
  var pages = _ref.pages,
      menuSettings = _ref.menuSettings;
  var expandSubItem = menuSettings.expandSubItem,
      showSearchbar = menuSettings.showSearchbar;
  var displayPages = (0, _react.useMemo)(function () {
    return [].concat((0, _toConsumableArray2["default"])(pages), (0, _toConsumableArray2["default"])(!showSearchbar ? [] : searchBarItem));
  }, [pages, showSearchbar]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.root, " ").concat(expandSubItem ? styles.expand : '')
  }, displayPages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_NavItem["default"], {
      key: page.id,
      page: page,
      menuSettings: menuSettings
    });
  })));
};

var _default = Nav;
exports["default"] = _default;